import { ThirdPartyLicenses, getThirdPartyLicensesEndpoint } from 'cpes-common';
import { createCmsContentSlice } from 'cms-integration';

const { reducer, fetchContent } = createCmsContentSlice<ThirdPartyLicenses>({
    contentName: 'thirdPartyLicenses',
    contentEndpoint: getThirdPartyLicensesEndpoint,
});

export default reducer;
export const fetchThirdPartyLicenses = fetchContent;
